import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "select-options" }, null, -1)

import {
  computed,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
} from 'vue';
import { useStore } from 'vuex';
import BaseHeader from '@/components/BaseHeader.vue';
import BaseFooter from '@/components/BaseFooter.vue';
import Enlargement from '@/components/Enlargement.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const isLoading = computed(() => store.getters['page/status'] === 1);
const isOrderPage = computed(() => store.getters['page/pageType'] === 'order');
const showEnlargement = computed(() => store.getters['enlargement/show']);

onBeforeMount(() => {
  store.dispatch('cart/fetch');
  store.dispatch('categories/fetch');
  store.dispatch('branches/fetch');
});

onMounted(() => {
  window.addEventListener('resize', window.runIoEqualize);
  window.addEventListener('load', window.runIoEqualize);
  window.runIoEqualize();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', window.runIoEqualize);
  window.removeEventListener('load', window.runIoEqualize);
});

return (_ctx: any,_cache: any) => {
  const _component_BaseLoader = _resolveComponent("BaseLoader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseHeader),
    (isOrderPage.value && isLoading.value)
      ? (_openBlock(), _createBlock(_component_BaseLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createVNode(BaseFooter),
    (showEnlargement.value)
      ? (_openBlock(), _createBlock(Enlargement, { key: 1 }))
      : _createCommentVNode("", true),
    _hoisted_1
  ], 64))
}
}

})